class productDeailTab extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.num = 0;
      this.tabTop = {}
      this.slideScrollTopArrays = {};
      this.header = document.documentElement.clientWidth > 996 ? document.querySelector('sticky-header').offsetHeight + 20 : document.querySelector('sticky-header').offsetHeight + document.querySelector('announcement-bar').offsetHeight + 20
    }
    connectedCallback(){
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        if(this.dataset.img){
            this.querySelectorAll(`product-size[data-body-type="${this.dataset.selectType}"] .size-header`).forEach(item=>{
                item.innerHTML += `
                    <div class="size-info-imgae-wrapper" style="--image-m:url('${this.dataset.imgM}');--image-pc:url('${this.dataset.img}')">
                        <use-animate data-animate="zoom-fade" class="media-wrapper multicolumn-card__image-wrapper multicolumn-card__image-wrapper--full-width" animate="">
                            <div class="image-animate media media--adapt media--image-contain">   
                                
                            </div>
                        </use-animate>
                    </div>
                `
            })
        }
        this.init();
        // window.addEventListener('scroll', ()=>{
        //     const rect = this.querySelectorAll('.product-deals-info-wrapper .swiper-slide')[0].getBoundingClientRect().top;
        //     console.log('Current top:', rect);
        // }, { passive: true });
        
    }
    init(){
        // this.waitForAllDivsLoaded()
        window.addEventListener('load', ()=>{
            let that = this;
            new Promise((resolve, reject)=>{
                if(this.querySelector('.product-deail-tab-swiper')){
                    this.tabHeight = this.querySelector('.product-deail-tab-swiper').offsetHeight
                    this.tabWrapper = this.querySelectorAll('.product-deail-tab-swiper .swiper-slide');
                    this.tabLength = this.tabWrapper.length;
                    let initTop = this.getBoundingClientRect().top - this.header;
                    let preSlideHeight = 0;
                    // this.querySelectorAll('.product-deals-info-wrapper .product-deals-info-slide').forEach((item,index)=>{
                    //     this.observeEvent(item)
                    //     if(index == 0){
                    //         this.slideScrollTopArrays[index] = initTop
                    //         preSlideHeight += initTop + item.getBoundingClientRect().height
                    //     }
                    //     else{
                    //         this.slideScrollTopArrays[index] = preSlideHeight;
                    //         preSlideHeight += item.getBoundingClientRect().height + this.header
                    //     }
                        
                    // })
//                     new Swiper(`.product-deals-info-swiper-${this.dataset.id}`, {
//                         direction: 'vertical',
//                         slidesPerView: 'auto',
//                         freeMode: true,
//                         freeModeMomentum: false,
//                         mousewheel: true,
//                         resistanceRatio: 0,
//                         touchReleaseOnEdges: true,
//                         on: {
//                             init:function(){
//                                     that.querySelectorAll('.product-deals-info-wrapper .product-deals-info-slide').forEach((item,index)=>{
//                                         // that.slideScrollTopArrays[index] = item.getBoundingClientRect().top - that.tabHeight;
//                                         that.getAccurateBoundingClientRect(item).then(topValue => that.slideScrollTopArrays[index] = topValue)
//                                     })
//                                  console.log(this.slideScrollTopArrays)
//                             }
//                         }
//                     });
                    resolve();
                }
            }).then(()=>{
                let preSlideHeight = 0;
                this.querySelectorAll('.product-deail-tab-swiper .swiper-slide').forEach((item,index)=>{
                    item.onclick = ()=>{
                        this.flag = true;
                        let initTop = 0;
                        if(item.getAttribute('data-move')){
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                            });
                            this.querySelectorAll('.product-deail-tab-swiper .swiper-slide')[0].classList.add('is-active')
                            this.querySelectorAll('.product-deail-tab-swiper .swiper-slide')[this.index].classList.remove('is-active')
                            this.index = 0;
                            return;
                        }
                        if(index == this.index) return;
                        item.classList.add('is-active');
                        this.querySelectorAll('.product-deail-tab-swiper .swiper-slide')[this.index].classList.remove('is-active')
                        initTop = document.querySelector('.custom-product').offsetHeight;
                        preSlideHeight = initTop + document.querySelector(`.product-deals-info-slide[data-index="0"]`).offsetHeight,
                        setTimeout(()=>{
                            if(index == 0){
                                let that = this;
                                window.scrollTo({
                                    top:initTop + this.header,
                                    behavior: 'smooth',
                                }); 
                            }
                            else if (index == 1){
                                window.scrollTo({
                                    top:initTop + document.querySelector(`.product-deals-info-slide[data-index="${index - 1}"]`).offsetHeight,
                                    behavior: 'smooth',
                                });
                            }
                            else{
                                window.scrollTo({
                                    top:document.querySelector(`.product-deals-info-slide[data-index="${index - 1}"]`).offsetHeight + preSlideHeight + this.tabHeight,
                                    behavior: 'smooth',
                                });
                            }
                            
                            this.index = index;
                            setTimeout(()=>{
                                this.flag = false;
                            })
                        },500)
                    }
                })
            }).then(()=>{
                
            })
        })
    }
    observeEvent(target,index){
        let that = this;
        const io = new IntersectionObserver((entries) => {
            entries.forEach(item => {
                if(item.isIntersecting) {
                    setTimeout(()=>{
                        if(this.index != item.target.getAttribute('data-index') && !this.flag){
                            this.querySelector(`.product-deail-tab-swiper .swiper-slide[data-index="${this.index}"]`).classList.remove('is-active');
                            this.querySelector(`.product-deail-tab-swiper .swiper-slide[data-index="${item.target.getAttribute('data-index')}"]`).classList.add('is-active');
                            this.index = item.target.getAttribute('data-index');
                        }
                    },200)
                }
            })
        })
        io.observe(target)
    }
    waitForAllDivsLoaded() {
        const parentDiv = document.querySelector('.custom-product');
        if (!parentDiv) {
            console.error('Parent div not found');
            return;
        }

        const childDivs = parentDiv.querySelectorAll('div');
        if (childDivs.length === 0) {
            console.warn('No child divs found');
            callback();
            return;
        }

        let loadedCount = 0;
        const totalDivs = childDivs.length;

        childDivs.forEach(div => {
            if (div.complete || div.readyState === 'complete') {
                loadedCount++;
                if (loadedCount === totalDivs) {
                    callback();
                }
            } else {
                div.addEventListener('load', () => {
                    loadedCount++;
                    if (loadedCount === totalDivs) {
                        callback();
                    }
                });
            }
        });
    }
}
customElements.define('product-deail-tab', productDeailTab);